import { render } from "./evaAgeSubjectEchart.vue?vue&type=template&id=3d10e01b&scoped=true"
import script from "./evaAgeSubjectEchart.vue?vue&type=script&lang=js"
export * from "./evaAgeSubjectEchart.vue?vue&type=script&lang=js"

import "./evaAgeSubjectEchart.vue?vue&type=style&index=0&id=3d10e01b&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d10e01b"]])

export default __exports__